import { identity } from 'ramda';
import {
  selectDirectBillPlan,
  selectDirectBillOePlanYearStart,
  setOeValidationsByPlanType,
} from 're-enrollment-checklist/re-enrollment-checklist.slice';
import { noop } from 'shared/utils';
import yupErrorsToObject from 'store/middleware/validators/utils/yupErrorsToObject';
import { directBillChecklistValidationSchema as validationSchema }
  from 're-enrollment-checklist/direct-bill-reenrollment-checklist/direct-bill-checklist.validators';
import store from 'store';

export const validate = (appStore: typeof store) => (next: any) => async (action: any) => {
  if (action) {
    next(action);
  }

  if (
    action.type.includes('reEnrollmentChecklist/setDirectBill')
      && !action.type.includes('reEnrollmentChecklist/setDirectBillOeValidations')
  ) {
    const state = appStore.getState();
    const directBillPlan = selectDirectBillPlan(state);
    const validations = await validationSchema
      .validate(directBillPlan, { stripUnknown: true, abortEarly: false })
      .then(noop)
      .catch(identity);
    const validation = yupErrorsToObject(validations?.errors ?? []);
    const planYearStart = selectDirectBillOePlanYearStart(state);
    appStore.dispatch(setOeValidationsByPlanType({
      type: 'directBill',
      planYearStart,
      ...validation,
    }));
  }
};
